const formHelpers = {
    data() {
		return {
			isProcessing: null,
			errorMessage: null,
		};
    },
	computed: {
		successMessage: {
			get() {
				return this.$store.getters['global/successMessage'];
			},
			set(message) {
				this.$store.commit('global/setSuccessMessage', message);
			},
		},
	},
	methods: {
		getErrorMessage(error) {
			// TODO: account for all situations
			return error.response.data.message[0];
		},
		flashSuccess(message, milliseconds, emit) {
			this.successMessage = message;

			if (!milliseconds) {
				milliseconds = 1000;
			}

			setTimeout(() => {
				this.successMessage = null;

				if (emit) {
					this.$emit(emit);
				}
			}, milliseconds);
		},
	},
};

export default formHelpers;